import React from 'react';
import PropTypes from 'prop-types';
import '../../styles/core.scss';
import css from './book-cover.scss';


const BookCover = ({ imageUrl, title, type, isSelected, onBookSwitch }) => {
    const cover = isSelected ? `${css.bookCover} ${css.highlight}` : `${css.bookCover} ${css.default}`;

    return (
        <div tabIndex={0} className={css.component} onClick={onBookSwitch} role="button">
            <div className={cover}><img src={imageUrl} alt={title} /></div>
            <div className={css.bookType}>{type}</div>
        </div>
    );
};

BookCover.propTypes = {
    imageUrl: PropTypes.string,
    type: PropTypes.string,
    title: PropTypes.string,
    isSelected: PropTypes.bool,
    onBookSwitch: PropTypes.func
};

export default BookCover;
